import {
  Button,
  CssBaseline,
  TextField,
  Link,
  Grid,
  Box,
  Typography,
  Container,
  CircularProgress,
} from "@mui/material";
import logo from "../images/transparent-logo.png";
import { fetchViaPost } from "../helpers/fetchViaPost";
import { useState } from "react";

function Copyright(props) {
  return (
    <Typography
      variant="body2"
      color="text.secondary"
      align="center"
      {...props}
    >
      {"Copyright © "}
      <Link color="inherit" href="https://betty.works/">
        betty
      </Link>{" "}
      {new Date().getFullYear()}
      {"."}
    </Typography>
  );
}

export function SignIn({ setAuth }) {
  const [loading, setLoading] = useState(false);

  const handleSubmit = async (event) => {
    setLoading(true);

    event.preventDefault();
    const data = new FormData(event.currentTarget);

    const response = await (
      await fetchViaPost(
        "sign-in",
        JSON.stringify({
          email: data.get("email"),
          password: data.get("password"),
        })
      )
    ).json();

    if (response.ok) window.location.pathname = response.token;

    setLoading(false);
  };

  return loading ? (
    <Box
      style={{
        display: "flex",
        height: "100vh",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <CircularProgress />
    </Box>
  ) : (
    <Container component="main" maxWidth="xs">
      <CssBaseline />
      <Box
        sx={{
          marginTop: 8,
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
        }}
      >
        <img src={logo} alt="betty" style={{ width: "10em" }} />
        <Typography component="h1" variant="h5">
          Sign in
        </Typography>
        <Box component="form" onSubmit={handleSubmit} sx={{ mt: 1 }}>
          <TextField
            margin="normal"
            required
            fullWidth
            id="email"
            label="Email Address"
            name="email"
            autoComplete="email"
            autoFocus
          />
          <TextField
            margin="normal"
            required
            fullWidth
            name="password"
            label="Password"
            type="password"
            id="password"
            autoComplete="current-password"
          />
          <Button
            type="submit"
            fullWidth
            variant="contained"
            sx={{ mt: 3, mb: 1 }}
          >
            Sign In
          </Button>

          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={() => {
                setAuth("forgot-password");
                window.location.pathname = "forgot-password";
              }}
            >
              Forgot password?
            </Button>
          </Grid>

          <Grid
            container
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
            }}
          >
            <Button
              onClick={() => {
                setAuth("sign-up");
                window.location.pathname = "sign-up";
              }}
            >
              {"Don't have an account? Sign Up"}
            </Button>
          </Grid>
        </Box>
      </Box>
      <Copyright sx={{ mt: 8, mb: 4 }} />
    </Container>
  );
}
